define('lq/events/actions/backgroundTask',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function BackgroundTask(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(BackgroundTask, EventAction);

    BackgroundTask.typeName = 'BackgroundTask';

    BackgroundTask.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    BackgroundTask.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "BackgroundTask",
            morphId: this.eventData.command
        };
    };

    BackgroundTask.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    return BackgroundTask;
});
